import type {
  GeoImportWorksJoinToProject,
  GeoImportWorksLeaveCurrentProject,
  MlNotificationsHubCloseProject,
  MlNotificationsHubOpenProject,
  ObjectTreeCloseProjectTree,
  ObjectTreeDeleteElementSignature,
  ObjectTreeDeleteElementsToTrashByName,
  ObjectTreeDeleteElementToTrashByNameForWell,
  ObjectTreeOpenProjectTree,
  PickerProgressHubJoinProject,
  PickerProgressHubLeaveProject,
  ProgressHubJoinProject,
  ProgressHubLeaveProject,
} from '@core/core/api'

import { getAction } from './helpers'
import { signalRSlice } from './signalrs'

type ConnectionToHubWithTokenSignature = { connect: [] }

export const { addConnection, updateConnection } = signalRSlice.actions

// Projects
export const startConnectingProjects = getAction<ConnectionToHubWithTokenSignature>(
  'startConnecting',
  'ProjectsHub',
)

// ML
export const startConnectingML = getAction<ConnectionToHubWithTokenSignature>(
  'startConnecting',
  'MlHub',
)
export const openProjectML = getAction<MlNotificationsHubOpenProject>(
  'openProject',
  'MlHub',
  'async',
  'JoinToProject',
)
export const closeProjectML = getAction<MlNotificationsHubCloseProject>(
  'closeProject',
  'MlHub',
  'async',
  'LeaveProject',
)

// Object Tree
export const startConnectingTreeObjects = getAction<ConnectionToHubWithTokenSignature>(
  'startConnecting',
  'ObjectTreeHub',
)
export const openProjectTree = getAction<ObjectTreeOpenProjectTree>(
  'openProject',
  'ObjectTreeHub',
  'async',
  'OpenProject',
)
export const closeProjectTree = getAction<ObjectTreeCloseProjectTree>(
  'closeProject',
  'ObjectTreeHub',
  'async',
  'CloseProject',
)
export const deleteElementToTrashForce = getAction<ObjectTreeDeleteElementSignature>(
  'DeleteElementToTrashForce',
  'ObjectTreeHub',
  'async',
  'DeleteElementToTrashForce',
)
export const deleteElementToTrashByNameForWell =
  getAction<ObjectTreeDeleteElementToTrashByNameForWell>(
    'DeleteElementToTrashByNameForWell',
    'ObjectTreeHub',
    'async',
    'DeleteElementToTrashByNameForWell',
  )
export const deleteElementsToTrashByName = getAction<ObjectTreeDeleteElementsToTrashByName>(
  'DeleteElementsToTrashByName',
  'ObjectTreeHub',
  'async',
  'DeleteElementsToTrashByName',
)

// Picker
export const startConnectingProgress = getAction<ConnectionToHubWithTokenSignature>(
  'startConnecting',
  'PickerProgressHub',
)
export const joinToProjectPickerProgress = getAction<PickerProgressHubJoinProject>(
  'joinToProjectPickerProgress',
  'PickerProgressHub',
  'async',
  'JoinToProject',
)
export const leaveProjectPickerProgress = getAction<PickerProgressHubLeaveProject>(
  'leaveProjectPickerProgress',
  'PickerProgressHub',
  'async',
  'LeaveProject',
)

//Seismic Import
export const startConnectingSeismicImportProgress = getAction<ConnectionToHubWithTokenSignature>(
  'startConnecting',
  'SeismicImportProgressHub',
)
export const joinToProjectSeismicImport = getAction<ProgressHubJoinProject>(
  'joinToProjectSeismicImport',
  'SeismicImportProgressHub',
  'async',
  'JoinToProject',
)
export const leaveProjectSeismicImport = getAction<ProgressHubLeaveProject>(
  'leaveProjectSeismicImport',
  'SeismicImportProgressHub',
  'async',
  'LeaveProject',
)

// Geo Import
export const startConnectingGeoImportWorks = getAction<ConnectionToHubWithTokenSignature>(
  'startConnecting',
  'GeoImportWorksHub',
)
export const joinToProjectGeoImportWorks = getAction<GeoImportWorksJoinToProject>(
  'joinToProjectGeoImportWorks',
  'GeoImportWorksHub',
  'async',
  'JoinToProject',
)
export const leaveProjectGeoImportWorks = getAction<GeoImportWorksLeaveCurrentProject>(
  'leaveProjectGeoImportWorks',
  'GeoImportWorksHub',
  'async',
  'LeaveCurrentProject',
)
